import { FC, HTMLAttributes } from "react";
import { useStyles } from "./TabsList.styles";
import clsx from "classnames";
import { useTranslation } from "react-i18next";

interface ITabsListProps {
  activeTab?: string;
  onChangeTab: (tab: string) => void;
  listTabs: string[];
  tabVariant?: "contained" | "outlined" | "underlined";
}

export const TabsList: FC<ITabsListProps & HTMLAttributes<HTMLDivElement>> = ({
  listTabs,
  activeTab,
  onChangeTab,
  tabVariant = "underlined",
  ...otherProps
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={clsx(classes.root, tabVariant, otherProps.className)}>
      {listTabs.map((tab, idx) => (
        <button
          key={tab}
          onClick={(e) => {
            onChangeTab(tab);
            e.currentTarget.scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: "nearest",
            });
          }}
          className={clsx(classes.button, tabVariant, {
            active: activeTab === tab,
          })}
          data-testid={`${tab
            .toLowerCase()
            .replace(/\s*\(\d+\)/g, "")
            .trim()
            .replace(/\s+/g, "-")}-tab`}
        >
          {t(tab)}
        </button>
      ))}
    </div>
  );
};
